module.exports = __webpack_public_path__ + "d8c966a72484cdbb23d6b84c5268396a.png";